import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@mui/material/styles'
import Drawer from '@mui/material/Drawer'
import CssBaseline from '@mui/material/CssBaseline'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Icon from '@mui/material/Icon'
import UseViewer from './useViewer'
import { classes, ViewerStyle } from './style'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { getUnitWithDetails, setGeometryData, setUnitData } from '../../actions/viewerActions'
import { Typography } from '@mui/material'
import Loading from '../../components/loading'

import { initialDetails } from './listDetails'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'

export default function Viewer () {
  const dispatch = useDispatch()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [showLoading, setShowLoading] = useState(true)
  const [details, setDetails] = useState(initialDetails)

  const unit = useSelector(state => state.viewer.unitDetails)
  const unitDetailsStore = useSelector(state => state.viewer.unitDetails)

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const updateDetails = () => {
    const addValuesDetails = details.map((item) => {
      const name = item.key
      item.value = unitDetailsStore[name]
      return item
    })

    setDetails(addValuesDetails)
  }

  const selectGeometry = (open, intersect = {}) => {
    const properties = get(intersect, 'userData.properties', intersect)
    const geometryData = open ? properties : {}
    dispatch(setGeometryData(geometryData))

    dispatch(setUnitData({}))
    !isEmpty(geometryData) && dispatch(getUnitWithDetails(geometryData.id))
    open && setShowLoading(true)
    setOpen(open)
  }

  useEffect(() => {
    !isEmpty(unitDetailsStore) && updateDetails()
    !isEmpty(unitDetailsStore) && setShowLoading(false)
  }, [JSON.stringify(unitDetailsStore), unitDetailsStore])

  return (
        <ViewerStyle className={classes.root}>
            <CssBaseline />
            <Drawer open={open} className={classes.drawer} variant="persistent" anchor="left" classes={{ paper: classes.drawerPaper }}>
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <div style={{ position: 'relative', height: '100%' }}>
                    <Loading open={showLoading} position="absolute"/>
                    <div>
                        <List className={classes.contentList}>
                            {details.map((item, index) => (
                                <div key={item.key}>

                                    <ListItem button >
                                        <ListItemIcon>
                                            <Icon>{item.icon}</Icon>
                                        </ListItemIcon>
                                        <ListItemText style={{ borderLeft: 'solid 3px red', paddingLeft: 10 }}>
                                            <Typography variant="caption" color="textPrimary" style={{ textTransform: 'capitalize' }}>
                                                {item.label}:
                                            </Typography>
                                            <Typography variant="body1" color="textSecondary" style={{ textTransform: 'capitalize' }}>
                                                {item.value} {item.key === 'surface' && <span style={{ textTransform: 'lowercase' }}>m<sup>2</sup></span>}
                                            </Typography>
                                        </ListItemText>

                                    </ListItem>
                                    <Divider/>
                                </div>
                            ))}
                        </List>
                    </div>
                    <div>
                        <Button variant="outlined" color="primary">View Plane</Button>
                        &nbsp;
                        &nbsp;
                        <Link to={'/viewer/' + unit.buildingID + '/unit/' + unit.id} style={{ textDecoration: 'none' }}>
                            <Button
                                variant="contained"
                                disabled={!unit.available}
color="primary"
                            >
                                View Unit
                            </Button>
                        </Link>
                    </div>

                </div>
            </Drawer>
            <main className={clsx(classes.content)}>
                <div style={{ height: '100vh', width: '100vw', overflowX: 'hidden', boxSizing: 'border-box' }} id="my-content-model">
                    <UseViewer
                        onCallbackClick={selectGeometry}
                    />
                </div>
            </main>
        </ViewerStyle>
  )
}
